import { fabric } from 'fabric';

/**
 * Returns the canvas pointer for an event, clamped to the visible canvas area.
 * Prevents shapes from being drawn outside the canvas (where they are invisible)
 * when the user drags the cursor past the canvas edges.
 */
export default function getClampedPointer(
  canvas: fabric.Canvas,
  e: Event
): { x: number; y: number } {
  const pointer = canvas.getPointer(e);

  const vpt = (canvas as any).vptCoords as
    | { tl: fabric.Point; br: fabric.Point }
    | undefined;

  const minX = vpt ? Math.min(vpt.tl.x, vpt.br.x) : 0;
  const minY = vpt ? Math.min(vpt.tl.y, vpt.br.y) : 0;
  const maxX = vpt ? Math.max(vpt.tl.x, vpt.br.x) : canvas.getWidth();
  const maxY = vpt ? Math.max(vpt.tl.y, vpt.br.y) : canvas.getHeight();

  return {
    x: Math.min(Math.max(pointer.x, minX), maxX),
    y: Math.min(Math.max(pointer.y, minY), maxY)
  };
}
